import { uuidv4 } from '@firebase/util';
import { Form } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ErrorNotification from '../../../../../common/components/notification/ErrorNotification';
import { NOTIFICATION_TITLE } from '../../../../../common/constants/MESSAGE';
import { RootState } from '../../../../../store';
import { ReSummarySubmittedOutsourceCompanyOffsetCost } from '../../entity/Entity';
import { CM0025_2UseCase } from '../../usecase/ServiceImpl';
import { setIsVisibleCM0025_2, setLoadingCM0025_2 } from '../slice/Slice';

const CM0025_2Handler = (CM0025_2Service: CM0025_2UseCase) => {
    // LIB FUNCTION
    const dispatch = useDispatch();

    //STATE
    const [form] = Form.useForm();
    const typeModal = useSelector((state: RootState) => state.cm0025_2.typeModal);

    const [
        listReSummarySubmittedOutsourceCompanyOffsetCostLocal,
        setListReSummarySubmittedOutsourceCompanyOffsetCostLocal,
    ] = useState<ReSummarySubmittedOutsourceCompanyOffsetCost[]>([]);
    const [totalCost, setTotalCost] = useState<number>(0);

    //function
    const getReSummarySubmittedOutsourceCompanyOffsetCost = async (
        documentSummaryOutsourceCostCompanyDataId: number,
        categoryId: number,
    ): Promise<any> => {
        try {
            dispatch(setLoadingCM0025_2(true));
            const params = {
                documentSummaryOutsourceCostCompanyDataId,
                categoryId,
            };
            const res = await CM0025_2Service.getReSummarySubmittedOutsourceCompanyOffsetCost(
                params,
            );
            if (res?.results) {
                const data = formatReSummarySubmittedOutsourceCompanyOffsetCost(res.results);
                setListReSummarySubmittedOutsourceCompanyOffsetCostLocal(data);
            }
        } catch (error: any) {
            ErrorNotification(error?.message ?? NOTIFICATION_TITLE.ERROR);
        } finally {
            dispatch(setLoadingCM0025_2(false));
        }
    };

    const formatReSummarySubmittedOutsourceCompanyOffsetCost = (data: any) => {
        const arr: ReSummarySubmittedOutsourceCompanyOffsetCost[] = data.map(
            (item: any, index: number) => {
                return {
                    key: uuidv4(),
                    id: item?.id,
                    item: item.name,
                    taxCategoryComsumptionId: item?.category?.id,
                    taxCategoryComsumptionName: item?.category?.description,
                    offsetAmount: item?.value,
                };
            },
        );
        return arr;
    };

    const handleCalculateChange = (data: ReSummarySubmittedOutsourceCompanyOffsetCost[]) => {
        let total: number = 0;
        data.forEach((item) => {
            const cost = item?.offsetAmount
                ? item.offsetAmount
                : form.getFieldValue(`offsetAmount${item.key}`) ?? 0;
            if (!isNaN(cost)) total += cost;
        });
        setTotalCost(total);
    };

    const onCancel = () => {
        dispatch(setIsVisibleCM0025_2(false));
    };

    return {
        form,
        typeModal,
        listReSummarySubmittedOutsourceCompanyOffsetCostLocal,
        totalCost,
        onCancel,
        handleCalculateChange,
        getReSummarySubmittedOutsourceCompanyOffsetCost,
    };
};

export default CM0025_2Handler;
